import { render } from "./AboutModal.vue?vue&type=template&id=58dfa8ef&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=58dfa8ef&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dfa8ef"]])

export default __exports__